module.exports = __webpack_public_path__ + "googleIcon.f05240e.png";